interface CrewMarkProps {
  className?: string | undefined
  title?: string | undefined
}

/**
 * El sello del Crew: dos anillos, las siglas y las cuatro marcas cardinales.
 * Es la misma figura que el anillo de progreso rellena durante el entreno.
 */
export function CrewMark({ className, title }: CrewMarkProps) {
  return (
    <svg className={className} viewBox="0 0 200 200" role={title ? 'img' : 'presentation'} aria-label={title}>
      <circle cx="100" cy="100" r="80" fill="none" stroke="var(--crema)" strokeWidth="5" />
      <circle cx="100" cy="100" r="62" fill="none" stroke="var(--crema)" strokeWidth="2" opacity="0.4" />
      <text
        x="100"
        y="118"
        textAnchor="middle"
        fontFamily="Archivo Black, sans-serif"
        fontSize="48"
        letterSpacing="-2"
        fill="var(--crema)"
      >
        TFC
      </text>
      <rect x="96.5" y="13.5" width="7" height="13" rx="3.5" fill="var(--terracota)" />
      <rect x="96.5" y="173.5" width="7" height="13" rx="3.5" fill="var(--terracota)" />
      <rect x="13.5" y="96.5" width="13" height="7" rx="3.5" fill="var(--terracota)" />
      <rect x="173.5" y="96.5" width="13" height="7" rx="3.5" fill="var(--terracota)" />
    </svg>
  )
}
